module.exports = __webpack_public_path__ + "static/media/bulb.b80c472d.webp";